import {
  ACTIVATE_CONFIG_ASYNC,
  DATA_REQUEST_ASYNC,
  FETCH_LICENSED_DOMAINS_ASYNC,
  UPDATE_CONFIG_ASYNC,
  VALIDATE_CONNECTION_ASYNC,
} from './constants'

export const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
export const fetchDataSuccess = (data) => ({ type: DATA_REQUEST_ASYNC.SUCCESS, payload: { data } })
export const fetchDataError = (error, errorType = null) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
  errorType,
})
export const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })

export const validateConnection = () => ({ type: VALIDATE_CONNECTION_ASYNC.INITIATE })
export const validateConnectionSuccess = (data) => ({
  type: VALIDATE_CONNECTION_ASYNC.SUCCESS,
  payload: { data },
})
export const validateConnectionError = (error, errorType = null) => ({
  type: VALIDATE_CONNECTION_ASYNC.ERROR,
  error,
  errorType,
})

export const activateConfig = () => ({ type: ACTIVATE_CONFIG_ASYNC.INITIATE })
export const activateConfigSuccess = (data) => ({
  type: ACTIVATE_CONFIG_ASYNC.SUCCESS,
  payload: { data },
})
export const activateConfigError = (error, errorType = null) => ({
  type: ACTIVATE_CONFIG_ASYNC.ERROR,
  error,
  errorType,
})

export const updateConfig = (payload) => ({ type: UPDATE_CONFIG_ASYNC.INITIATE, payload })
export const updateConfigSuccess = (data) => ({
  type: UPDATE_CONFIG_ASYNC.SUCCESS,
  payload: { data },
})
export const updateConfigError = (error, errorType = null) => ({
  type: UPDATE_CONFIG_ASYNC.ERROR,
  error,
  errorType,
})

export const fetchLicensedDomains = () => ({ type: FETCH_LICENSED_DOMAINS_ASYNC.INITIATE })
export const fetchLicensedDomainsSuccess = (domains) => ({
  type: FETCH_LICENSED_DOMAINS_ASYNC.SUCCESS,
  payload: { domains },
})
export const fetchLicensedDomainsError = (error) => ({
  type: FETCH_LICENSED_DOMAINS_ASYNC.ERROR,
  error,
})

export default {
  fetchData,
  fetchDataCancel,
  validateConnection,
  activateConfig,
  updateConfig,
  fetchLicensedDomains,
}
